import { Injectable } from '@angular/core';
import { Cor } from '@tivic-team/manager-ts/dist/fta/';
import { HttpGet, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';


@Injectable()
export class CorController{

    constructor() {}

	async get(cdCor:number):Promise<Cor>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'fta/cor/:cdCor',
					environment: environment,
					pathParams: new JSONData({cdCor: cdCor})
				}),
			}),
			new HttpResponse(
			  new Cor()
			)
		);
		return await quark.call();
    }
    
    async find(filtros?:IFilter):Promise<Array<Cor>>{
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'fta/cor',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Cor>()
            )
        );
        return await quark.call();
    }
}